import React from 'react';
import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

const STEP_KEYS = ['quick', 'detailed', 'metadata', 'review'] as const;

const InstructionsAlert: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Alert variant="info">
      <Info className="h-4 w-4" />
      <AlertTitle className="revy-cjk leading-[1.5]">
        {t('testUpload.instructionsTitle')}
      </AlertTitle>
      <AlertDescription>
        {/* The island resets ol to list-style:none with no padding, so an
            ordered list has to ask for its markers back. */}
        <ol className="revy-cjk list-decimal space-y-1 pl-5 text-sm leading-[1.7]">
          {STEP_KEYS.map((step) => (
            <li key={step}>{t(`testUpload.instructions.${step}`)}</li>
          ))}
        </ol>
      </AlertDescription>
    </Alert>
  );
};

export default InstructionsAlert;
